import { Routes, Route, Navigate } from "react-router-dom";
import { routes, ROUTES } from "./Routes";

const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Navigate to={ROUTES.HOME.path} replace />
        }
      />

      {routes.map((route, idx) => (
        <Route
          key={idx}
          path={route.path}
          element={route.element}
        />
      ))}

      <Route path="*" element={<Navigate to={ROUTES.ERROR404.path} replace />} />
    </Routes>
  );
};

export default AppRoutes;
